<template>
    <div class="custom-modal" @click="closeCustomModal()">

        <div class="custom-modal-window" @click.stop>
            <div class="btn-close" @click="closeCustomModal()"></div>

            <div class="custom-modal-body" v-if="fetcher.initialized">

                <div class="container-fluid">
                    <h2 class="mb-6 text-dark" v-if="manager.name == ''">Ny användare</h2>
                    <h2 class="mb-6 text-dark">{{ manager.name }}</h2>
                </div>

                <div class="container-fluid pt-5 pb-10">

                    <div class="row">
                        <div class="col-24 col-lg-12 mb-12 mb-lg-0">

                            <h3 class="mb-4">Redigera personuppgifter</h3>

                            <input-text
                                name="name"
                                label="Namn"
                                v-model="manager.name"
                            />

                            <input-text
                                name="email"
                                label="E-postadress"
                                v-model="manager.email"
                            />

                            <input-select
                                name="type"
                                label="Behörighet"
                                v-model="manager.type"
                                :options="[
                                    {value: 'admin', label: 'Administratör'},
                                    {value: 'regular', label: 'Användare'},
                                ]"
                                v-if="manager.id !== auth.id"
                            />

                            <div class="d-flex justify-content-start justify-content-xl-end">
                                <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                                    <span class="spinner-border spinner-border-sm me-1"></span>
                                    <span v-if="manager.invited_at">Spara uppgifter</span>
                                    <span v-else>Spara och bjud in</span>
                                </button>
                            </div>
                        </div>
                        <div class="d-none d-xl-block col-xl-3">
                        </div>
                        <div class="col-24 col-lg-12 col-xl-9" v-if="manager.id !== auth.id">
                            <div class="row">
                                <div class="col-24 mb-12">
                                    <h3>Inaktivera kontot</h3>
                                    <p>Ett inaktiverat konto är spärrat och går inte att logga in med. Du kan återaktivera det här igen.</p>
                                    <poster-button
                                        btn-class="btn btn-info"
                                        :url="'/data/managers/' + manager.id + '/disableAccount'"
                                        @success="inactivateSuccess()"
                                    >
                                        <span v-if="manager.disabled_at">Återaktivera kontot</span>
                                        <span v-else>Inaktivera kontot</span>
                                    </poster-button>
                                </div>
                                <div class="col-24">
                                    <h3>Radera kontot</h3>
                                    <p>Ett raderat konto tas bort helt, och alla personuppgifter rensas.</p>
                                    <poster-button
                                        btn-class="btn btn-danger"
                                        :url="'/data/managers/' + manager.id + '/deleteAccount'"
                                        confirm="Vill du verkligen ta bort kontot? Det kan inte ångras."
                                        @success="deleteSuccess()"
                                    >
                                        Radera kontot
                                    </poster-button>
                                </div>
                            </div>
                        </div>
                        <div class="col-24 col-lg-12 col-xl-8" v-else>
                            <h3>Inaktivera och radera</h3>
                            <p>Det går inte att inaktivera eller radera det konto du är inloggad på</p>
                        </div>
                    </div>

                </div>

            </div>

            <div class="custom-modal-body loading-employee-placeholder" v-else>

                <div class="container-fluid">

                    <div class="placeholder-glow w-100">
                        <span class="placeholder bg-light col-24 col-lg-12 mb-6 rounded-1 headline"></span>
                    </div>

                    <div class="container-fluid pt-5 pb-10" style="height: 320px;">

                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>

import modaler from '../../../shared/mixins/modaler'
import fetcher from '../../../shared/mixins/fetcher'
import patcher from '../../../shared/mixins/patcher'

import PosterButton from '../../../shared/components/poster-button'

export default {

    mixins: [
        modaler,
        fetcher,
        patcher
    ],

    components: {
        PosterButton
    },

    props: {
        manager_id: {
            required: true
        }
    },

    data () {
        return {
            manager: null,
            fetcher: {
                autoFill: [
                    'manager'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/managers/' + this.manager_id
        },
        patcherUrl () {
            return '/data/managers/' + this.manager_id
        },
        patcherData () {
            return this.manager
        }
    },

    methods: {
        patcherSuccess () {
            this.closeCustomModal(true)
            bus.$emit(
                'notify',
                'Användarkontot har sparats'
            )
        },
        inactivateSuccess () {
            this.closeCustomModal(true)
            bus.$emit(
                'notify',
                'Användarkontot har inaktiverats'
            )
        },
        deleteSuccess () {
            this.closeCustomModal(true)
            bus.$emit(
                'notify',
                'Användarkontot har raderats'
            )
        }
    }
}
</script>
